<template>
    <div class="l-edit-dialog-box">
        <el-form :model="form_data" label-width="120px" ref="form" label-position="left" v-loading="loading">

            <el-form-item label="理由" prop="remark">
                <el-input type="textarea" v-model="form_data.remark" autocomplete="off" :rows="4" maxlength="250"
                    placeholder="请输入理由" show-word-limit></el-input>
            </el-form-item>

        </el-form>
        <div class="l-dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'l-user-additional-info',
    props: {
        id: {
            type: [String, Number],
            default: null
        },
        cz_state: {
            type: [String, Number],
            default: null
        },

    },
    components: {
    },
    computed: {
        hasId() {
            return this.$props.id !== null;
        },
    },
    data() {
        return {
            submitting:false,
            loading: false,//页面是否加载中
            //表单数据
            form_data: {
                remark: "",
            },
        }
    },
    methods: {
   //点击取消通知父组件关闭对话框
   cancel() {
      this.$emit('update:visible', false);
    },
        //提交数据
        handleSubmit() {
            this.submitting = true;
            this.$_invoke(`adminUserAdditional_update`, {
                id: this.$props.id,
                cz_state: this.$props.cz_state,
                remark:this.form_data.remark
            }).then(() => {
                this.$_msg.success('修改成功');
                this.$emit('on-success');
            }).finally(() => {
                this.submitting = false;
            })
        }
    }

}
</script>